export enum TPlatform {
    WEB = 1,
    APP = 2,
}

export enum TTemplate {
    GDPR    = 1
}

export enum TParamGroup {
    'GDPR'          = 1,
    'CMP'           = 2,
    'ANALYTIC'      = 3,
    'CONSENT_MODE'  = 4,
    'INSIST_MODE'   = 5,
    'ADDTL_CONSENT' = 6,
    'INSIST'        = 7,
    'AUTO_ACCEPT'   = 8
}

export enum TParamAnalytic {
    ENABLED     = 'analytic_enabled',
    PROVIDER    = 'analytic_provider'
}

export enum TParamConsentMode {
    ENABLED     = 'ga4_consent_mode_enabled',
    MODE        = 'ga4_consent_mode_mode'
}

export enum TParamInsistMode {
    ENABLED                             = 'insist_mode_enabled',
    SECONDARY_PLATFORM_ACTION_ENABLED   = 'insist_mode_secondary_action_enabled',
    INSIST_MODE_DIRECT_APPROVE          = 'insist_mode_direct_approve',
}

export enum TParamAddtlConsent {
    VERSION = 'addtl_consent_version'
}

export enum TParamAutoAccept {
    ENABLED     = 'auto_accept_enabled',
    FORCE_SHOW  = 'auto_accept_force_show',
    PRIVACY_URL = 'auto_accept_privacy_url'
}
